/* Gallery and independently configured flavor products for the GLP landing pages. */
(() => {
  if (window.__rtnuGlpCommerceInitialized) return;
  window.__rtnuGlpCommerceInitialized = true;

  const initialized = new WeakSet();

  // Reuse the globally loaded Embla instance and PDP hero options.
  function initGallery(root) {
    if (root.hidden) return;
    if (root._emblaApi) { root._emblaApi.reInit(); return; }
    const viewport = root.querySelector('.glp-offer__viewport');
    const slides = [...root.querySelectorAll('.glp-offer__slide')];
    const thumbs = [...root.querySelectorAll('.glp-offer__thumb')];
    if (!viewport || slides.length < 2 || typeof EmblaCarousel !== 'function') return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const api = EmblaCarousel(viewport, {
      align: 'start', containScroll: 'trimSnaps', slidesToScroll: 1,
      duration: reducedMotion.matches ? 0 : 25,
    });
    root._emblaApi = api;
    const listeners = new AbortController();
    const prev = root.querySelector('.glp-offer__arrow--prev');
    const next = root.querySelector('.glp-offer__arrow--next');
    const sync = () => {
      const selected = api.selectedScrollSnap();
      slides.forEach((slide, index) => {
        const current = index === selected;
        slide.classList.toggle('is-current', current);
        slide.setAttribute('aria-hidden', String(!current));
        slide.toggleAttribute('inert', !current);
      });
      thumbs.forEach((thumb, index) => {
        thumb.classList.toggle('is-current', index === selected);
        if (index === selected) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = !api.canScrollPrev();
      if (next) next.disabled = !api.canScrollNext();
    };
    prev?.addEventListener('click', () => api.scrollPrev(), { signal: listeners.signal });
    next?.addEventListener('click', () => api.scrollNext(), { signal: listeners.signal });
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => api.scrollTo(index), { signal: listeners.signal }));
    root.addEventListener('keydown', (event) => {
      if (!event.target.closest('.glp-offer__viewport, .glp-offer__thumbs')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        if (event.key === 'ArrowLeft') api.scrollPrev();
        else api.scrollNext();
      }
    }, { signal: listeners.signal });
    reducedMotion.addEventListener('change', () => api.reInit({ duration: reducedMotion.matches ? 0 : 25 }), { signal: listeners.signal });
    api.on('select', sync).on('reInit', sync);
    sync();
    root._emblaCleanup = () => {
      listeners.abort();
      api.destroy();
      delete root._emblaApi;
      delete root._emblaCleanup;
    };
  }

  function init(root) {
    root.querySelectorAll('[data-glp-offer], [data-glp-protocol]').forEach((section) => {
      if (initialized.has(section)) return;
      initialized.add(section);
      const radios = [...section.querySelectorAll('[data-product-option-input]')];
      const showOption = (id) => {
        section.querySelectorAll('[data-product-option]').forEach((panel) => {
          panel.hidden = panel.dataset.productOption !== id;
          if (!panel.hidden && panel.matches('[data-offer-gallery]')) initGallery(panel);
        });
        radios.forEach((radio) => { radio.checked = radio.value === id; });
      };
      radios.forEach((radio) => radio.addEventListener('change', () => {
        if (radio.checked) showOption(radio.value);
      }));
      if (radios.length) showOption(radios.find((radio) => radio.checked)?.value || radios[0].value);
      section.querySelectorAll('[data-offer-gallery]').forEach(initGallery);
      section.addEventListener('shopify:block:select', (event) => {
        const radio = radios.find((item) => item.value === event.detail.blockId);
        if (radio) showOption(radio.value);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-offer-gallery]').forEach((gallery) => gallery._emblaCleanup?.());
    event.target.querySelectorAll('[data-glp-offer], [data-glp-protocol]').forEach((section) => initialized.delete(section));
  });
})();
